import * as React from "react"
import * as styles from "./styles.module.scss"

const MissionWhat: React.FC = () => {
  return (
    <section className={styles.dictionary}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Rebuilding the mortgage process</h2>
          <p className={styles.subhead}>
            We are singularly focused on changing the way Americans get a
            mortgage. Step-by-step we are taking apart the old mortgage
            infrastructure and replacing it with thoughtful technology.
          </p>
        </div>
        <ul className={styles.list}>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <h4 className={styles.itemHeading}>Available 24/7</h4>
            <p className={styles.description}>
              Our site is available nights and weekends, not only during
              bankers’ hours.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <h4 className={styles.itemHeading}>Instant Loan Estimate</h4>
            <p className={styles.description}>
              Don’t wait three days to know what you’ll owe. We’ll give you a
              Loan Estimate in seconds.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <h4 className={styles.itemHeading}>Radical transparency</h4>
            <p className={styles.description}>
              Our online portal allows you to see exactly where you are in the
              process every step of the way.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <h4 className={styles.itemHeading}>No commission</h4>
            <p className={styles.description}>
              We're trying to get you into the best loan possible to meet your
              needs, not to reach our bottom line.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <h4 className={styles.itemHeading}>No origination fees</h4>
            <p className={styles.description}>
              We’re not like cell phone companies who charge you a fee at the
              end of the process to hook it all up.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <h4 className={styles.itemHeading}>Honest rate quotes</h4>
            <p className={styles.description}>
              No bait-and-switch. No hidden fees. No BS.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <h4 className={styles.itemHeading}>On-demand rate lock</h4>
            <p className={styles.description}>
              Lock your rate when you're ready, not when your bank is ready.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <h4 className={styles.itemHeading}>Bank account integration</h4>
            <p className={styles.description}>
              Just log into your bank account with our integration, and we'll
              take care of the rest.
            </p>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default MissionWhat
